import { Grid, useTheme } from "@mui/material";
import { PropertyGroup } from "src/context/Property/Builder/PropertyBuilder";
import { DisplayValue } from "./DisplayValue";

type DisplayGroupProps = {
    property: PropertyGroup;
};
export const DisplayGroup = (props: DisplayGroupProps) => {
    const theme = useTheme();
    const maxCols = 12;
    const colNumber = 2;

    return (
        <Grid container>
            {props.property.content.map((property, idx) => {
                const isLeftCol = idx % colNumber === 0;
                return (
                    <Grid
                        item
                        key={`${idx}-group-property`}
                        xs={maxCols / colNumber}
                        sx={{
                            borderLeft: isLeftCol ? "none" : `1px dashed ${theme.custom.grey[500]}`,
                            borderBottom: `1px dashed ${theme.custom.grey[500]}`,
                        }}
                    >
                        <DisplayValue withTitle property={property} />
                    </Grid>
                );
            })}
        </Grid>
    );
};
